<footer class='footer'>
  <div class='main-container'>
    <h2 class='sr-only'>stopka {{ name }}</h2>
    <div class='links' id='footer-links'>
      <a routerLink='/strona-glowna' class='logo'>
        <img [src]='appLogoPath' alt='' width='30' aria-hidden='true'>
        <span class='sr-only'>Strona główna <span class='sr-only'>{{ name }}</span></span> {{ name }}
      </a>
      <ul class="subpages">
        <li><a routerLink='/e-uslugi'>E-Usługi</a></li>
        <li><a routerLink='/platnosci-online'>Płatności online</a></li>
        <li><a routerLink='/info/polityka-prywatnosci'>Polityka prywatności</a></li>
        <li><a routerLink='/info/regulamin'>Regulamin</a></li>
        <li><a routerLink='/info/deklaracja-dostepnosci'>Deklaracja dostępności</a></li>
        <li><a routerLink='/info/kontakt'>Kontakt</a></li>
      </ul>
      <br>
    </div>
    @if (showFooterEULogotypes) {
      <div class='eu-logotypes'>
        <img class="d-block" style="width: 100%; height: auto" src="/img/icons/eu/loga_ue.jpg"
             alt="Logotypy: Fundusze Europejskie dla Wielkopolski, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską, Podkarpackie">
      </div>
    }
  </div>
</footer>
<div class='appVersion'>Version: {{ version }}</div>
